import React from "react";
import "./services.css"; // Import CSS for this component
import { Button } from "../../utils/button";

import content from "../../content.json";

const imagesContext = require.context('../../Items', false, /\.(png|jpe?g|svg|webp)$/);

const Services = () => {
  return (
    <section id="services">
      <div className="service-headings">
        <h1>Our
          <span className="services-gradient"> Services</span>
        </h1>
      </div>
      <div className="service-cards">
        {Object.keys(content.service_cards).map((key) => {
          const service = content.service_cards[key];
          let imageSrc = '';
          try {
            if (service.image) {
              imageSrc = imagesContext(`./${service.image}`);
            }
          } catch (error) {
            console.error(`Image not found: Please try once again ${service.image}`);
          }

          return (
            <div
              className="service-card"
              key={key}
              style={{ '--bg-image': `url(${imageSrc})` }}
              role="img"
              aria-label={`${service.title} service background`}
            >
              <div className="card-heading">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
              <div className="card-button">
                <Button
                  text="Learn More  ▶"
                  onClick={() => {
                    // to the specific service page
                    window.location.href = `/services/${key}`;
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
